module.exports = __webpack_public_path__ + "static/festive-aab543e5ccbd0c696f5c7d01b9901fb7.jpg";